import script from "./SettingsChangeLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsChangeLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsChangeLanguage.vue?vue&type=style&index=0&id=621a2f43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621a2f43"]])

export default __exports__